(function () {
  if (customElements.get("product-form")) return;

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[action*="/cart/add"]');
      if (!this.form || this.bound) return;
      this.bound = true;
      this.form.addEventListener("submit", (event) => this.onSubmit(event));
      this.querySelectorAll("[data-skip-cart-button]").forEach((button) => {
        button.addEventListener("click", () => this.submit(button, true));
      });
    }

    onSubmit(event) {
      event.preventDefault();
      this.submit(event.submitter, false);
    }

    async submit(submitter, forceSkipCart) {
      if (!this.form) return;
      if (this.form.reportValidity && !this.form.reportValidity()) return;
      const button = submitter || this.querySelector('[type="submit"]');
      this.setLoading(button, true);
      this.clearError();

      const formData = new FormData(this.form);
      this.syncQuantityBreaks(formData);

      try {
        const response = await fetch((window.routes && window.routes.cart_add_url) || "/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw data;
        this.dispatchEvent(new CustomEvent("product-form:added", { bubbles: true, detail: { data } }));
        const skipCart = forceSkipCart || this.form.querySelector(".product-variant-id[data-skip-cart]");
        if (skipCart) window.location.href = "/checkout";
      } catch (error) {
        this.showError(error && (error.description || error.message) ? error.description || error.message : "There was an error adding this item to the cart.");
      } finally {
        this.setLoading(button, false);
      }
    }

    syncQuantityBreaks(formData) {
      const sectionId = this.dataset.section;
      const selector = sectionId ? document.getElementById(`quantity-breaks-${sectionId}`) : null;
      const quantityBreaks = selector || document.querySelector("quantity-breaks");
      if (!quantityBreaks) return;
      const checked = quantityBreaks.querySelector('input[type="radio"][name="quantity"]:checked');
      if (!checked) return;
      formData.set("quantity", checked.value || "1");
      const selectedBreak = this.getBreakForRadio(quantityBreaks, checked);
      if (!selectedBreak) return;
      const selectedVariantIds = Array.from(selectedBreak.querySelectorAll(".quantity-break__selector-item"))
        .map((item) => item.dataset.selectedId || item.querySelector(".quantity-break__variant-select")?.dataset.productId)
        .filter(Boolean);
      if (selectedVariantIds.length < 1) return;
      const bundleId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      formData.delete("id");
      formData.delete("quantity");
      selectedVariantIds.forEach((variantId, index) => {
        formData.append(`items[${index}][id]`, variantId);
        formData.append(`items[${index}][quantity]`, "1");
        formData.append(`items[${index}][properties][_bundle_slot]`, String(index + 1));
        formData.append(`items[${index}][properties][_bundle_id]`, bundleId);
      });
    }

    getBreakForRadio(quantityBreaks, radio) {
      if (!quantityBreaks || !radio || !radio.id) return null;
      return Array.from(quantityBreaks.querySelectorAll("label.quantity-break")).find((label) => label.getAttribute("for") === radio.id) || null;
    }

    setLoading(button, loading) {
      const buttons = button ? [button] : Array.from(this.querySelectorAll("button"));
      buttons.forEach((item) => {
        item.classList.toggle("loading", loading);
        item.toggleAttribute("aria-disabled", loading);
      });
      this.querySelectorAll(".loading-overlay__spinner").forEach((spinner) => {
        spinner.classList.toggle("hidden", !loading);
      });
    }

    clearError() {
      const wrapper = this.querySelector(".product-form__error-message-wrapper");
      const message = this.querySelector(".product-form__error-message");
      const inline = this.querySelector(".main-atc__error");
      if (wrapper) wrapper.hidden = true;
      if (message) message.textContent = "";
      if (inline) {
        inline.textContent = "";
        inline.style.display = "none";
      }
    }

    showError(messageText) {
      const wrapper = this.querySelector(".product-form__error-message-wrapper");
      const message = this.querySelector(".product-form__error-message");
      const inline = this.querySelector(".main-atc__error");
      if (wrapper) wrapper.hidden = false;
      if (message) message.textContent = messageText;
      if (inline) {
        inline.textContent = messageText;
        inline.style.display = "inline";
      }
    }
  }

  customElements.define("product-form", ProductForm);
})();
